import React from 'react';
import SignInPage from './pages/SignIn';

function App() {
    return (
        <SignInPage />
    );
}

export default App;